"use client";

import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { IMakeModelActualResponse, IMakeModelPageContent } from "api/interfaces/get-page-details/make-model-page.type";
import { IMakeActualResponse, IMakePageContent } from "api/interfaces/get-page-details/make-page.type";
import { PAGE_TYPES } from "../../util/product/product-constants";
import MakeModelPage from "./MakeModelPage";
import MakePage from "./MakePage";

interface IProps{
  pageType: string;
  urlInformation: IUrlInformation;
  staticContent: IMakePageContent | IMakeModelPageContent;
  actualResponse: IMakeModelActualResponse | IMakeActualResponse;
}

function MakeMakeModelPage(props: IProps) {
  const {
    pageType, actualResponse, urlInformation, staticContent,
  } = props;
  switch (pageType) {
  case PAGE_TYPES.MAKE_PAGE:
    return (
      <MakePage {...{
        pageType, actualResponse, urlInformation, staticContent,
      }}
      />
    );
  case PAGE_TYPES.MAKE_MODEL_PAGE:
    return (
      <MakeModelPage {...{
        pageType, actualResponse, urlInformation, staticContent,
      }}
      />
    );
  default:
    return "null";
  }
}

export default MakeMakeModelPage;
